var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShotStyle',{ref:"ShotTextArea"}),_c('SimpleKeyboard',{ref:"Keyboard",attrs:{"next-input":_vm.nextKey,"show-gesture":true,"input":_vm.input},on:{"onChange":_vm.onChange,"onKeyPress":_vm.onKeyPress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }